import type { ConflitoJustificativaProps } from "./types-conflito-justificativa";
import { useConflitoJustificativa } from "./use-conflito-justificativa";
import { ConflitoJustificativaView } from "./view-conflito-justificativa";

/** Justificativa obrigatória dos três fluxos de conflito (RN05/RN06), limitada como na auditoria. */
export function ConflitoJustificativa(props: ConflitoJustificativaProps) {
  const vm = useConflitoJustificativa(props);

  return <ConflitoJustificativaView {...vm} />;
}

export type * from "./types-conflito-justificativa";
